/*
  GOFLEX : JavaScript commun du thème (porté depuis le <script> de custom-liquid/00-base.liquid).
  Chargé en defer par layout/theme.liquid, après le petit <script> qui pose window.GF.routes et window.GF.currency.

  Ce que fait ce fichier :
  - initialisation idempotente (attribut data-gf-init) au DOMContentLoaded et à chaque shopify:section:load (éditeur de thème) ;
  - conteneur de défilement : .page-wrapper quand Horizon le fait défiler (>= 990 px), sinon window ; le header [data-header]
    « qui se cache en descendant » écoute le bon conteneur ;
  - tiroirs [data-drawer="menu"|"cart"], voile [data-overlay], recherche [data-search], boutons [data-open] / [data-close] (délégation) ;
  - barre d'annonce [data-ticker], méga menus [data-mega], rangées [data-drag], onglets [data-tabs], carrousels
    [data-image-carousel] / [data-scroll-carousel] / [data-review-carousel], fiche produit ([data-thumbs], [data-sizes],
    [data-colors], [data-bundle], [data-sticky-cart], .gf-product__info), logos presse, apparition au scroll (.gf-reveal) ;
  - panier AJAX : formulaires [action*="/cart/add"] des sections GOFLEX (submit), POST sur routes.cart_add + '.js', puis
    rechargement du tiroir [data-drawer="cart"] par l'API de rendu de sections (id lu dans data-section-id) et ouverture ;
    quantité et suppression dans le tiroir via [data-line][data-quantity] (ou [data-key]) sur routes.cart_change + '.js'.

  API publique (window.GF) : GF.init(root), GF.scroller(), GF.scrollY(), GF.drawer.open(name), GF.drawer.close(),
  GF.cart.add(form | FormData), GF.cart.change({ line | id, quantity }), GF.cart.refresh(), GF.cart.sectionId(), GF.money(cents).
  Événements émis sur document : gf:cart:added, gf:cart:changed, gf:cart:updated ({ detail: { count } }), gf:cart:error.
*/
(function () {
  'use strict';

  var GF = (window.GF = window.GF || {});
  GF.routes = GF.routes || {};

  var $ = function (selector, root) { return (root || document).querySelector(selector); };
  var $$ = function (selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); };
  var body = document.body;
  var desktop = window.matchMedia('(min-width: 990px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ----- Outils ----- */

  /* Marque un élément comme initialisé pour une clé ; renvoie false s'il l'était déjà (ré-injection par l'éditeur) */
  function once(el, key) {
    if (!el) return false;
    var done = (el.getAttribute('data-gf-init') || '').split(' ').filter(Boolean);
    if (done.indexOf(key) !== -1) return false;
    done.push(key);
    el.setAttribute('data-gf-init', done.join(' '));
    return true;
  }

  /* Éléments correspondant au sélecteur dans root, root compris */
  function find(root, selector) {
    var list = $$(selector, root);
    if (root !== document && root.matches && root.matches(selector)) list.unshift(root);
    return list;
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true }));
  }

  /* ----- Conteneur de défilement (Horizon fait défiler .page-wrapper à partir de 990 px) ----- */

  function scroller() {
    var wrapper = $('.page-wrapper');
    if (wrapper && desktop.matches) {
      var overflow = getComputedStyle(wrapper).overflowY;
      if (overflow === 'auto' || overflow === 'scroll') return wrapper;
    }
    return window;
  }

  function scrollY() {
    var target = scroller();
    return target === window ? window.scrollY : target.scrollTop;
  }

  /* ----- Header : sticky qui se cache en descendant et réapparaît en remontant ----- */

  var tracking = 0;
  var ticking = false;

  function headerEl() { return $('[data-header]'); }

  function headerWrapper() {
    var header = headerEl();
    return header ? header.closest('.shopify-section') : null;
  }

  function setHeaderVisible(visible) {
    var header = headerEl();
    if (!header) return;
    if (!visible && ($('.gf-header__nav-item.gf-is-open') || body.classList.contains('gf-is-locked'))) return;
    header.classList.toggle('gf-is-hidden', !visible);
    var wrapper = headerWrapper();
    if (wrapper) wrapper.classList.toggle('gf-is-hidden', !visible);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var header = headerEl();
      if (!header) return;
      var y = Math.max(0, scrollY());
      header.classList.toggle('is-scrolled', y > 10);
      if (y > tracking && y - tracking > 100) { tracking = y; setHeaderVisible(false); }
      else if (y < tracking) { tracking = y; setHeaderVisible(true); }
    });
  }

  /* Pose --header-height et --header-group-height sur body (lues par les composants Horizon conservés : compte, tiroir, page panier) */
  function measureHeader() {
    var header = headerEl();
    if (!header) return;
    body.style.setProperty('--header-height', Math.round(header.getBoundingClientRect().height) + 'px');
    var group = $('#header-group');
    if (group) {
      var total = 0;
      Array.prototype.forEach.call(group.children, function (child) { total += child.offsetHeight; });
      body.style.setProperty('--header-group-height', total + 'px');
    }
  }

  /* ----- Tiroirs (menu, panier), recherche et voile ----- */

  function drawer(name) { return $('[data-drawer="' + name + '"]'); }
  function overlayEl() { return $('[data-overlay]'); }
  function searchEl() { return $('[data-search]'); }

  function closeAll() {
    $$('[data-drawer]').forEach(function (d) { d.classList.remove('gf-is-open'); d.setAttribute('aria-hidden', 'true'); });
    var overlay = overlayEl();
    if (overlay) { overlay.classList.remove('gf-is-open'); overlay.style.top = ''; }
    var search = searchEl();
    if (search) search.classList.remove('gf-is-open');
    var header = headerEl();
    if (header) header.classList.remove('gf-is-search-open');
    var wrapper = headerWrapper();
    if (wrapper) wrapper.classList.remove('gf-is-search-open');
    body.classList.remove('gf-is-locked');
    $$('[data-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* Ouvre « menu », « cart » ou « search » ; renvoie false si l'élément n'existe pas sur la page */
  function openDrawer(name) {
    closeAll();
    var header = headerEl();
    var overlay = overlayEl();
    if (name === 'search') {
      var search = searchEl();
      if (!search) return false;
      setHeaderVisible(true);
      search.classList.add('gf-is-open');
      if (header) header.classList.add('gf-is-search-open');
      var wrapper = headerWrapper();
      if (wrapper) wrapper.classList.add('gf-is-search-open');
      if (overlay) {
        overlay.style.top = header ? Math.max(0, header.getBoundingClientRect().bottom) + 'px' : '';
        overlay.classList.add('gf-is-open');
      }
      body.classList.add('gf-is-locked');
      var input = $('input', search);
      if (input) input.focus();
    } else {
      var target = drawer(name);
      if (!target) return false;
      setHeaderVisible(true);
      target.classList.add('gf-is-open');
      target.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('gf-is-open');
      body.classList.add('gf-is-locked');
    }
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    return true;
  }

  function isOpen(name) {
    var el = name === 'search' ? searchEl() : drawer(name);
    return !!(el && el.classList.contains('gf-is-open'));
  }

  /* ----- Panier AJAX ----- */

  function jsonRoute(route, fallback) {
    return String(route || fallback).replace(/\.js$/, '') + '.js';
  }

  function request(url, options) {
    options = options || {};
    var headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers || {});
    options.headers = headers;
    options.credentials = 'same-origin';
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.description || data.message || ('Erreur ' + response.status));
          error.status = response.status;
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  /* Id de section du tiroir panier : data-section-id sur [data-drawer="cart"], sinon sur un ancêtre, sinon l'id de l'enveloppe Shopify */
  function cartSectionId() {
    var cart = drawer('cart');
    if (!cart) return null;
    var id = cart.getAttribute('data-section-id');
    if (!id) {
      var host = cart.closest('[data-section-id]');
      if (host) id = host.getAttribute('data-section-id');
    }
    if (!id) {
      var wrapper = cart.closest('.shopify-section');
      if (wrapper && wrapper.id) id = wrapper.id.replace(/^shopify-section-/, '');
    }
    return id || null;
  }

  function showCartError(message) {
    var cart = drawer('cart');
    if (!cart) { console.error('[GOFLEX panier]', message); return; }
    var box = $('[data-cart-error]', cart);
    if (!box) {
      box = document.createElement('p');
      box.className = 'gf-cart-error';
      box.setAttribute('data-cart-error', '');
      box.setAttribute('role', 'alert');
      var bodyEl = $('.gf-cart-drawer__body', cart) || cart;
      bodyEl.insertBefore(box, bodyEl.firstChild);
    }
    box.textContent = message || "Une erreur est survenue, merci de réessayer.";
    box.hidden = false;
    emit('gf:cart:error', { message: box.textContent });
  }

  function updateCartCount(count) {
    if (count === undefined || count === null || count === '') return;
    $$('[data-cart-count]:not([data-drawer])').forEach(function (el) {
      el.setAttribute('data-cart-count', count);
      el.textContent = count;
      if (el.hasAttribute('data-cart-count-hide-empty')) el.hidden = Number(count) === 0;
    });
  }

  /* Recharge le contenu du tiroir panier. markup : HTML de la section déjà reçu (sections de /cart/add.js), sinon fetch ?sections= */
  function refreshCart(markup) {
    var sectionId = cartSectionId();
    var cart = drawer('cart');
    if (!cart || !sectionId) return Promise.resolve(false);
    cart.setAttribute('aria-busy', 'true');
    var html = markup
      ? Promise.resolve(markup)
      : fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Rendu de section impossible (' + response.status + ')');
          return response.json();
        })
        .then(function (json) { return json[sectionId]; });
    return html.then(function (source) {
      if (!source) throw new Error('Section du tiroir introuvable (' + sectionId + ')');
      var doc = new DOMParser().parseFromString(source, 'text/html');
      var fresh = doc.querySelector('[data-drawer="cart"]');
      var current = drawer('cart');
      var count;
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        Array.prototype.forEach.call(fresh.attributes, function (attr) {
          if (attr.name.indexOf('data-') === 0 && attr.name !== 'data-gf-init') current.setAttribute(attr.name, attr.value);
        });
        count = fresh.getAttribute('data-cart-count');
        init(current);
      } else if (current) {
        var wrapper = current.closest('.shopify-section');
        var inner = doc.getElementById('shopify-section-' + sectionId);
        if (!wrapper) throw new Error('Enveloppe du tiroir introuvable');
        wrapper.innerHTML = inner ? inner.innerHTML : source;
        var replaced = drawer('cart');
        count = replaced ? replaced.getAttribute('data-cart-count') : undefined;
        init(wrapper);
      }
      var after = drawer('cart');
      if (after) after.removeAttribute('aria-busy');
      updateCartCount(count);
      emit('gf:cart:updated', { count: count === undefined ? null : Number(count) });
      return true;
    }).catch(function (error) {
      var after = drawer('cart');
      if (after) after.removeAttribute('aria-busy');
      throw error;
    });
  }

  function addToCart(source) {
    var form = source instanceof HTMLFormElement ? source : null;
    var data = source instanceof FormData ? source : new FormData(form);
    var sectionId = cartSectionId();
    if (sectionId && !data.has('sections')) {
      data.append('sections', sectionId);
      data.append('sections_url', window.location.pathname);
    }
    if (form) form.classList.add('gf-is-adding');
    return request(jsonRoute(GF.routes.cart_add, '/cart/add'), { method: 'POST', body: data })
      .then(function (added) {
        var markup = added && added.sections && sectionId ? added.sections[sectionId] : null;
        return refreshCart(markup).catch(function (error) { console.warn('[GOFLEX panier] tiroir non rechargé :', error.message); }).then(function () {
          openDrawer('cart');
          emit('gf:cart:added', { item: added });
          return added;
        });
      })
      .catch(function (error) {
        showCartError(error.message);
        openDrawer('cart');
        throw error;
      })
      .then(function (added) { if (form) form.classList.remove('gf-is-adding'); return added; }, function (error) { if (form) form.classList.remove('gf-is-adding'); throw error; });
  }

  /* payload : { line: 1, quantity: 2 } ou { id: 'clé de ligne', quantity: 0 } */
  function changeCart(payload, trigger) {
    var sectionId = cartSectionId();
    var request_body = Object.assign({}, payload);
    if (sectionId) { request_body.sections = sectionId; request_body.sections_url = window.location.pathname; }
    if (trigger && 'disabled' in trigger) trigger.disabled = true;
    var cart = drawer('cart');
    if (cart) cart.setAttribute('aria-busy', 'true');
    return request(jsonRoute(GF.routes.cart_change, '/cart/change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request_body),
    })
      .then(function (result) {
        var markup = result && result.sections && sectionId ? result.sections[sectionId] : null;
        return refreshCart(markup).then(function () {
          emit('gf:cart:changed', { cart: result });
          return result;
        });
      })
      .catch(function (error) {
        if (cart) cart.removeAttribute('aria-busy');
        if (trigger && 'disabled' in trigger) trigger.disabled = false;
        showCartError(error.message);
        throw error;
      });
  }

  function changeLine(el) {
    var quantity = Number(el.getAttribute('data-quantity'));
    if (isNaN(quantity)) return Promise.resolve(null);
    var payload = { quantity: Math.max(0, quantity) };
    if (el.hasAttribute('data-key')) payload.id = el.getAttribute('data-key');
    else payload.line = Number(el.getAttribute('data-line'));
    return changeCart(payload, el).catch(function () {});
  }

  /* ----- Délégation globale (clics, clavier, formulaires) : posée une seule fois ----- */

  function onClick(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var el;

    if ((el = target.closest('[data-open]'))) {
      var name = el.getAttribute('data-open');
      if (isOpen(name)) { closeAll(); event.preventDefault(); }
      else if (openDrawer(name)) event.preventDefault();
      return;
    }
    if (target.closest('[data-close]')) { event.preventDefault(); closeAll(); return; }
    if (target.closest('[data-overlay]')) { closeAll(); return; }

    if ((el = target.closest('[data-sub]'))) {
      var menu = el.closest('[data-drawer="menu"]');
      if (menu) menu.classList.toggle('gf-is-sub', el.getAttribute('data-sub') === 'open');
      return;
    }

    /* Lignes du tiroir panier : quantité et suppression */
    if ((el = target.closest('[data-drawer="cart"] [data-line], [data-drawer="cart"] [data-key]'))) {
      event.preventDefault();
      changeLine(el);
      return;
    }

    /* Sélecteur de quantité bouton + champ + bouton (hors tiroir) */
    if ((el = target.closest('.gf-qty button')) && !el.hasAttribute('data-line') && !el.hasAttribute('data-key')) {
      var box = el.closest('.gf-qty');
      var input = $('input', box);
      var buttons = $$('button', box);
      if (input && buttons.length >= 2) {
        var step = buttons.indexOf(el) === 0 ? -1 : 1;
        input.value = Math.max(1, Number(input.value || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if ((el = target.closest('.gf-upsell__switch'))) {
      el.setAttribute('aria-checked', String(el.getAttribute('aria-checked') !== 'true'));
      return;
    }

    /* Onglets */
    if ((el = target.closest('[data-tabs] [role="tab"]'))) {
      var root = el.closest('[data-tabs]');
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[role="tabpanel"]', root);
      var controls = el.getAttribute('aria-controls');
      if (controls) event.preventDefault();
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === el)); });
      panels.forEach(function (p) { p.classList.toggle('gf-is-active', p.id === controls); });
      return;
    }

    /* Bouton de démonstration hors formulaire : ouvre simplement le tiroir */
    if ((el = target.closest('[data-add-to-cart]')) && !el.closest('form')) {
      if (openDrawer('cart')) event.preventDefault();
    }
  }

  function onChange(event) {
    var input = event.target instanceof Element ? event.target.closest('[data-drawer="cart"] input[data-line], [data-drawer="cart"] input[data-key]') : null;
    if (!input) return;
    var quantity = Number(input.value);
    if (isNaN(quantity)) return;
    var payload = { quantity: Math.max(0, quantity) };
    if (input.hasAttribute('data-key')) payload.id = input.getAttribute('data-key');
    else payload.line = Number(input.getAttribute('data-line'));
    changeCart(payload, input).catch(function () {});
  }

  function onSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!form.closest('.gf, .gf-section')) return;
    if (form.hasAttribute('data-gf-native')) return;
    event.preventDefault();
    var submitter = event.submitter || null;
    if (submitter) submitter.classList.add('gf-is-adding');
    addToCart(form).catch(function () {}).then(function () { if (submitter) submitter.classList.remove('gf-is-adding'); });
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeAll();
  }

  function bindGlobal() {
    if (!once(document.documentElement, 'global')) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    var wrapper = $('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('screen and (pointer: fine)').matches) {
      document.addEventListener('mousemove', function (e) { if (e.clientY < 100) { setHeaderVisible(true); tracking = 0; } }, { passive: true });
    }
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    document.addEventListener('submit', onSubmit);
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', measureHeader);
    window.addEventListener('load', measureHeader);
  }

  /* ----- Barre d'annonce : duplique le contenu pour un défilement continu à vitesse constante ----- */

  function initTicker(root) {
    find(root, '[data-ticker]').forEach(function (ticker) {
      if (!once(ticker, 'ticker')) return;
      var chunk = ticker.firstElementChild;
      if (!chunk) return;
      var guard = 0;
      while (ticker.scrollWidth < window.innerWidth * 2 && guard < 8) { ticker.appendChild(chunk.cloneNode(true)); guard++; }
      Array.prototype.slice.call(ticker.children).forEach(function (c) { ticker.appendChild(c.cloneNode(true)); });
      var speed = Number(ticker.getAttribute('data-speed')) || 40; /* pixels par seconde */
      ticker.style.animationDuration = Math.max(1, ticker.scrollWidth / 2 / speed) + 's';
    });
  }

  /* ----- Méga menus (desktop) : survol avec léger délai, fermeture en fondu ----- */

  function initMega(root) {
    find(root, '[data-mega]').forEach(function (item) {
      if (!once(item, 'mega')) return;
      var btn = $('button', item);
      if (!btn) return;
      var timer;
      var open = function () {
        clearTimeout(timer);
        $$('[data-mega].gf-is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.add('gf-is-instant');
          other.classList.remove('gf-is-open');
          var b = $('button', other);
          if (b) b.setAttribute('aria-expanded', 'false');
          void other.offsetWidth;
          other.classList.remove('gf-is-instant');
        });
        item.classList.add('gf-is-open');
        btn.setAttribute('aria-expanded', 'true');
      };
      var close = function () {
        timer = setTimeout(function () { item.classList.remove('gf-is-open'); btn.setAttribute('aria-expanded', 'false'); }, 150);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      btn.addEventListener('click', function () {
        if (item.classList.contains('gf-is-open')) { clearTimeout(timer); item.classList.remove('gf-is-open'); btn.setAttribute('aria-expanded', 'false'); }
        else open();
      });
    });
  }

  /* ----- Défilement à la souris (drag) des rangées de cartes ----- */

  function initDrag(root) {
    find(root, '[data-drag]').forEach(function (el) {
      if (!once(el, 'drag')) return;
      var down = false, startX = 0, startScroll = 0, moved = false;
      el.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startScroll = el.scrollLeft; el.classList.add('gf-is-dragging'); });
      window.addEventListener('mouseup', function () { down = false; el.classList.remove('gf-is-dragging'); });
      el.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = startScroll - dx; });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    });
  }

  /* ----- Onglets : barre collante optionnelle (les clics sont gérés par délégation) ----- */

  function initTabs(root) {
    find(root, '[data-tabs]').forEach(function (tabs) {
      if (!once(tabs, 'tabs')) return;
      var nav = $('.gf-tabs-nav-wrap', tabs);
      if (nav && nav.getAttribute('data-sticky') === 'true') nav.classList.add('gf-is-sticky');
    });
  }

  /* ----- Carrousel d'images (4 visibles desktop, 1 par écran mobile) ----- */

  function initImageCarousel(root) {
    find(root, '[data-image-carousel]').forEach(function (wrap) {
      if (!once(wrap, 'image-carousel')) return;
      var track = $('.gf-image-carousel__track', wrap);
      var slides = $$('.gf-image-carousel__slide', wrap);
      var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap);
      var mq = window.matchMedia('(max-width: 768px)');
      if (!track) return;
      var index = 0;
      var per = function () { return mq.matches ? 1 : Number(wrap.getAttribute('data-visible')) || 4; };
      var max = function () { return Math.max(0, slides.length - per()); };
      var apply = function () {
        if (mq.matches) { track.style.transform = ''; track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' }); }
        else { track.style.transform = 'translateX(-' + (index * (100 / per())) + '%)'; }
      };
      if (next) next.addEventListener('click', function () { index = index < max() ? index + 1 : 0; apply(); });
      if (prev) prev.addEventListener('click', function () { index = index > 0 ? index - 1 : max(); apply(); });
      track.addEventListener('scroll', function () { if (mq.matches) index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }, { passive: true });
      mq.addEventListener('change', function () { index = 0; apply(); });
    });
  }

  /* ----- Carrousels natifs avec flèches flottantes ----- */

  function initScrollCarousel(root) {
    find(root, '[data-scroll-carousel]').forEach(function (wrap) {
      if (!once(wrap, 'scroll-carousel')) return;
      var row = $('.gf-scroll-row', wrap);
      var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap);
      if (!row) return;
      var step = function () { return row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 8 : row.clientWidth; };
      var sync = function () {
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  /* ----- Fiche produit : vignettes, tailles, couleurs, offre, barre collante, colonne épinglée, logos presse ----- */

  function initProduct(root) {
    find(root, '[data-thumbs]').forEach(function (thumbs) {
      if (!once(thumbs, 'thumbs')) return;
      var target = thumbs.getAttribute('data-thumbs') ? $(thumbs.getAttribute('data-thumbs')) : null;
      $$('button', thumbs).forEach(function (b, i) {
        b.addEventListener('click', function () {
          $$('button', thumbs).forEach(function (x) { x.classList.toggle('gf-is-active', x === b); });
          if (target) { var slide = $$('.gf-pgallery__slide', target)[i]; if (slide) target.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
        });
      });
    });

    find(root, '[data-sizes]').forEach(function (group) {
      if (!once(group, 'sizes')) return;
      $$('button', group).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          $$('button', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          $$('.gf-bundle__select').forEach(function (s) { if (s.firstChild && s.firstChild.nodeType === 3) s.firstChild.nodeValue = b.textContent.trim() + ' '; });
        });
      });
    });

    find(root, '[data-colors]').forEach(function (group) {
      if (!once(group, 'colors')) return;
      $$('button', group).forEach(function (b) {
        b.addEventListener('click', function () { $$('button', group).forEach(function (x) { x.classList.toggle('gf-is-active', x === b); }); });
      });
    });

    find(root, '[data-bundle]').forEach(function (group) {
      if (!once(group, 'bundle')) return;
      $$('input[type="radio"]', group).forEach(function (r) {
        r.addEventListener('change', function () { $$('.gf-bundle__option', group).forEach(function (o) { o.classList.toggle('gf-is-selected', o.contains(r)); }); });
      });
    });

    find(root, '[data-sticky-cart]').forEach(function (sticky) {
      if (!once(sticky, 'sticky-cart')) return;
      var anchor = $('[data-sticky-anchor]');
      if (!anchor || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('gf-is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    });

    find(root, '.gf-product__info').forEach(function (info) {
      if (!once(info, 'info')) return;
      var fit = function () { info.style.top = window.innerWidth >= 1000 ? Math.min(91, window.innerHeight - info.offsetHeight) + 'px' : ''; };
      fit();
      window.addEventListener('resize', fit);
      window.addEventListener('load', fit);
    });

    find(root, '.gf-press-logos').forEach(function (section) {
      if (!once(section, 'press')) return;
      var row = $('.gf-press-logos__row', section);
      var items = $$('.gf-press-logos__item', section);
      var dots = $$('.gf-press-logos__dots span', section);
      if (!row || !dots.length) return;
      row.addEventListener('scroll', function () {
        var best = 0, dist = Infinity;
        items.forEach(function (it, k) { var d = Math.abs(it.offsetLeft - row.offsetLeft - row.scrollLeft); if (d < dist) { dist = d; best = k; } });
        dots.forEach(function (d, k) { d.classList.toggle('gf-is-active', k === best); });
      }, { passive: true });
    });
  }

  /* ----- Cartes d'avis : piste, flèches et défilement automatique toutes les 5 s ----- */

  function initReviews(root) {
    find(root, '[data-review-carousel]').forEach(function (wrap) {
      if (!once(wrap, 'reviews')) return;
      var track = $('.gf-review-card__track', wrap);
      var cards = $$('.gf-review-card', wrap);
      var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap);
      if (!track || cards.length < 2) return;
      var index = 0, timer;
      var go = function (i, smooth) {
        index = (i + cards.length) % cards.length;
        track.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      };
      var auto = function () { clearInterval(timer); if (!reducedMotion.matches) timer = setInterval(function () { go(index + 1); }, 5000); };
      if (next) next.addEventListener('click', function () { go(index + 1); auto(); });
      if (prev) prev.addEventListener('click', function () { go(index - 1); auto(); });
      track.addEventListener('scroll', function () {
        var w = cards[0].getBoundingClientRect().width + 16;
        index = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / Math.max(1, w))));
      }, { passive: true });
      window.addEventListener('resize', function () { go(index, false); });
      auto();
    });
  }

  /* ----- Apparition au scroll ----- */

  var revealObserver = null;

  function initReveal(root) {
    var targets = find(root, '.gf-reveal').filter(function (el) { return once(el, 'reveal'); });
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(function (el) { el.classList.add('gf-is-visible'); }); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('gf-is-visible'); revealObserver.unobserve(e.target); } });
      }, { threshold: 0.12 });
    }
    targets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ----- Formatage monétaire (shop.money_format posé par le layout dans GF.money_format) ----- */

  function money(cents, format) {
    format = format || GF.money_format || '{{amount}}';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = match ? match[1] : 'amount';
    var n = Number(cents) / 100;
    if (!isFinite(n)) n = 0;
    var fmt = function (decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
      default: value = fmt(2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ----- Initialisation ----- */

  function init(root) {
    root = root && root.nodeType ? root : document;
    bindGlobal();
    initTicker(root);
    initMega(root);
    initDrag(root);
    initTabs(root);
    initImageCarousel(root);
    initScrollCarousel(root);
    initProduct(root);
    initReviews(root);
    initReveal(root);
    measureHeader();
  }

  GF.init = init;
  GF.scroller = scroller;
  GF.scrollY = scrollY;
  GF.money = money;
  GF.drawer = { open: openDrawer, close: closeAll, isOpen: isOpen };
  GF.cart = { add: addToCart, change: changeCart, refresh: refreshCart, sectionId: cartSectionId, error: showCartError };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Éditeur de thème : une section ajoutée ou modifiée est ré-injectée ; on initialise ce qui est nouveau */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', function () { measureHeader(); });
  document.addEventListener('shopify:section:unload', function () { closeAll(); });
})();
